import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { MessageCircleIcon, StarIcon } from 'lucide-react';
import { useStore } from '../../contexts/StoreContext';
const contacts = [{
  label: 'Administración general / Reclamos',
  phone: '1124687787',
  display: '11 2468-7787'
}, {
  label: 'Área ventas',
  phone: '1156449518',
  display: '11 5644-9518'
}];
export function Footer() {
  const {
    brands
  } = useStore();
  return <footer className="border-t border-line bg-ink" data-id="element-907" data-mp="q2lbkabbzlp">
      <div className="container-x grid gap-10 py-12 md:grid-cols-[1.4fr_1fr_1fr_1fr]" data-id="element-908" data-mp="3s2f547sro4re">
        <div data-id="element-909" data-mp="3n32dl9qya9ih">
          <Logo data-id="element-910" data-mp="3n4lw7702wwnf" />
          <p className="mt-4 max-w-xs text-sm text-mist" data-id="element-911" data-mp="3n43rdlzcpa3w">
            Todas las marcas en un solo lugar. Explorá, compará, simulá y recibí asesoramiento personalizado para tu 0 km.
          </p>

          <ul className="mt-6 space-y-3 text-sm" data-id="element-912" data-mp="3e2co0nsa9fd7">
            {contacts.map(c => <li key={c.label} data-id="element-913" data-mp="394ufuzm3b469">
                <p className="text-[11px] font-semibold uppercase tracking-wider text-mist" data-id="element-914" data-mp="395vz3rd9ewz2">{c.label}</p>
                <a href={`https://wa.me/549${c.phone}`} target="_blank" rel="noopener noreferrer" className="mt-0.5 inline-flex items-center gap-2 font-semibold text-white transition-colors duration-150 hover:text-wa" data-id="element-915" data-mp="2kba0vcizzk6n">
                  <MessageCircleIcon className="h-4 w-4 text-wa" aria-hidden data-id="element-916" data-mp="3413za9g7wxju" />
                  {c.display}
                </a>
              </li>)}
            <li data-id="element-917" data-mp="3825nzwcidr7k">
              <p className="text-[11px] font-semibold uppercase tracking-wider text-mist" data-id="element-918" data-mp="380l5x67ds0ql">Zona Oeste</p>
              <span className="mt-1 inline-block rounded-md border border-neon/60 bg-neon/10 px-2 py-0.5 text-xs font-bold tracking-wide text-neon-hi" data-id="element-919" data-mp="2u50l2583d8gj">
                PRÓXIMAMENTE
              </span>
            </li>
          </ul>

          <div className="mt-6 inline-flex flex-col gap-1.5 rounded-xl border border-silver/40 bg-surface px-4 py-3" data-id="element-920" data-mp="1nmkg9efzkdgz">
            <div className="flex gap-0.5" role="img" aria-label="5 de 5 estrellas" data-id="element-921" data-mp="13kziwyjlvp2p">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-5 w-5 fill-warn text-warn" aria-hidden data-id="element-922" data-mp="zjxpwzga8996" />)}
            </div>
            <p className="text-xs font-bold uppercase tracking-wider text-silver-hi" data-id="element-923" data-mp="uq2wv5esehxf">Agencia online 100% calificada y verificada</p>
          </div>
        </div>
        <div data-id="element-924" data-mp="kv16y7cotbts">
          <h2 className="text-sm font-semibold" data-id="element-925" data-mp="kvjdpxwz78fy">Explorar</h2>
          <ul className="mt-3 space-y-2 text-sm text-mist" data-id="element-926" data-mp="fuvnvfkhgxnb">
            <li data-id="element-927" data-mp="fxhtvarq753f"><Link className="hover:text-white" to="/catalogo" data-id="element-928" data-mp="fxhsb6c2ux1b">Catálogo 0 km</Link></li>
            <li data-id="element-929" data-mp="bvnzfk84ixbp"><Link className="hover:text-white" to="/simulador" data-id="element-930" data-mp="bvei0l159yhm">Simulador de financiación</Link></li>
            <li data-id="element-931" data-mp="6wtg8h68v6r2"><Link className="hover:text-white" to="/comparar" data-id="element-932" data-mp="6wthsllw7et6">Comparador</Link></li>
            <li data-id="element-933" data-mp="265i5j6gcyy8d"><Link className="hover:text-white" to="/chequeo" data-id="element-934" data-mp="265i3z20pmq69">Chequeo crediticio</Link></li>
          </ul>
        </div>
        <div data-id="element-935" data-mp="28s0p3kn9cmyt">
          <h2 className="text-sm font-semibold" data-id="element-936" data-mp="28sai7h3lna8q">Marcas</h2>
          <ul className="mt-3 space-y-2 text-sm text-mist" data-id="element-937" data-mp="28rqz3x27qft4">
            {brands.map(b => <li key={b.id} data-id="element-938" data-mp="2dp9adu3pd74a"><Link className="hover:text-white" to={`/marcas/${b.slug}`} data-id="element-939" data-mp="2dor382fi58hl">{b.name}</Link></li>)}
          </ul>
        </div>
        <div data-id="element-940" data-mp="2nhexapf3kycm">
          <h2 className="text-sm font-semibold" data-id="element-941" data-mp="2nfvg8wlmaj9s">VCARS</h2>
          <ul className="mt-3 space-y-2 text-sm text-mist" data-id="element-942" data-mp="1pt4vaafbaali">
            <li data-id="element-943" data-mp="1pupr03dd3zky"><Link className="hover:text-white" to="/chequeo#seguimiento" data-id="element-944" data-mp="1pupsk7t0g7n2">Seguimiento de consulta</Link></li>
            <li data-id="element-945" data-mp="1ushs9nzwcy1t"><Link className="hover:text-white" to="/admin" data-id="element-946" data-mp="1uuc2a79mr5r4">Panel de administración</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-line" data-id="element-947" data-mp="23so3t4c1bnyc">
        <div className="container-x space-y-2 py-6 text-[11px] leading-relaxed text-mist/80" data-id="element-948" data-mp="23uhagjmne86c">
          <p data-id="element-949" data-mp="3b5pthf9um9uk">
            Las simulaciones son cálculos matemáticos referenciales y no constituyen una oferta de crédito. Las ofertas financieras sólo se publican como tales cuando
            sus condiciones fueron verificadas por VCARS y están sujetas a aprobación de la entidad otorgante. La TNA no incluye seguros, gastos ni impuestos; el CFT
            se informa cuando la entidad lo provee.
          </p>
          <p data-id="element-950" data-mp="3nqep33w9ql3l">
            Las marcas y modelos mencionados pertenecen a sus respectivos titulares. VCARS es un comercializador multimarca independiente. Imágenes ilustrativas.
          </p>
          <p data-id="element-951" data-mp="it3d5vuxbyj">© {new Date().getFullYear()} VCARS · 0 km multimarca · Argentina</p>
        </div>
      </div>
    </footer>;
}